import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { Vendor } from './vendor';
import { MaterialType } from './material-type';

@JsonObject('model.cv.Material')
export class Material extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(Number, 'cvMaterialId')
    cvMaterialId?: number;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'sku')
    sku?: string;

    @JsonProperty(Number, 'estimatedQuantity')
    estimatedQuantity: number;

    @JsonProperty(Number, 'deliveredQuantity')
    deliveredQuantity: number;

    @JsonProperty(Number, 'cost')
    cost: number;

    @JsonProperty(Number, 'area')
    area: number;

    @JsonProperty(Number, 'orderedQuantity')
    orderedQuantity: number;

    @JsonProperty(String, 'type')
    type?: string;

    @JsonProperty(String, 'unit')
    unit?: string;

    @JsonProperty(Vendor, 'vendor')
    vendor?: Vendor;

    @JsonProperty(Boolean, 'backorder')
    backorder?: boolean;

}